const DEFAULT_FOCUSABLE =
  'a, button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

export default {
  bind: function (el, binding) {
    const enabled = binding.value !== false;

    if (!enabled) return;

    const focusables =
      typeof binding.value === 'string' ? binding.value : DEFAULT_FOCUSABLE;

    const trapFocusHandler = (e) => {
      if (e.key !== 'Tab') return;

      const container = el;
      if (!container) return;

      const focusable = container.querySelectorAll(focusables);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    el._trapFocusHandler = trapFocusHandler;
    window.addEventListener('keydown', trapFocusHandler);
  },

  unbind(el) {
    if (el._trapFocusHandler) {
      window.removeEventListener('keydown', el._trapFocusHandler);
      delete el._trapFocusHandler;
    }
  },
};
